import { getChallenges } from "@/services/challenge";
import { Challenge } from "@/types/challenge";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ChallengesStore {
  challenges: Challenge[];
  getAll: () => Promise<void>;
}
export const useChallengesStore = create<ChallengesStore>()(
  devtools((set, get) => ({
    challenges: [],
    getAll: async () => {
      const challenges = await getChallenges();
      set({ challenges });
    },
    getChallenges: (id: string) =>
      get().challenges.find((challenge) => challenge._id === id),
  })),
);
